export default class ruleProgressBar {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                type: '=',
                item: '=',
                progress: '=',
                data: '=',
                pollingState: '='
            },
            template: require('../../../../views/directives/rule-progress-bar.html'),
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$state', '$filter', '$stateParams', '$rootScope', 'ProgressBar',
                (scope, element, attrs, $timeout, $state, $filter, $stateParams, $rootScope, ProgressBar) => {

                var leftState = () => {
                    if (scope.type == 'campaign-export') {
                        return $state.current.name != 'campaign.index' && $state.current.name != 'campaign.folder';
                    }

                    return $state.current.name != scope.pollingState;
                };

                var processData = () => {

                    let percentage = 0;
                    if (scope.data.meta.total) {
                        percentage = ((scope.data.meta.current / scope.data.meta.total) * 100).toFixed(0);
                    } else {
                        percentage = scope.data.state === 'Finished' ? 100 : 0
                    }

                    if (scope.type == 'subscriber-import' || scope.type == 'campaign-export') {
                        scope.progressValue = scope.data.meta.current + " / " + scope.data.meta.total;
                    } else {
                        scope.progressValue = percentage + '%';
                    }

                    scope.progressCss = {
                        'width': percentage + '%',
                        'background': '#05cc87',
                        'height': '40px'
                    };
                };

                var finish = () => {
                    $timeout.cancel(scope.polling);

                    if (scope.type == 'segment-export' && ! leftState()) {
                        $rootScope.$emit('segment:export:completed', scope.data.url);
                    } else if (scope.type == 'tag-export' && ! leftState()) {
                        $rootScope.$emit('tag:export:completed', scope.data.url);
                    } else if (scope.type == 'subscriber-import' && ! leftState()) {
                        $rootScope.$emit('subscriber:import:completed', scope.data.meta.id);
                    } else if (scope.type == 'campaign-export' && ! leftState()) {
                        $rootScope.$emit('campaign:export:completed', scope.data.url);
                    }
                };

                var getProgress = (type, idToUse) => {
                    idToUse = idToUse ? idToUse : $stateParams.id;
                    ProgressBar.getData(type, idToUse, scope.dispatcherType).then((progress) => {
                        scope.data = progress;

                        if (scope.data) {
                            scope.progressText = ProgressBar.getText(type, scope.data.state, scope.data);

                            if (scope.data.meta) {
                                processData();
                            }

                            if (ProgressBar.isFinished(type, scope.data) || leftState()) {
                                return finish();
                            }
                        }
                    });
                };

                var pollProgress = (type, idToUse) => {
                    getProgress(type, idToUse);

                    scope.polling = $timeout(() => {
                        pollProgress(type, idToUse);
                    }, 4000);
                };

                var restartListener = $rootScope.$on('progress:start', (event, type, dispatcherType, idToUse) => {
                    if (scope.type == type) {
                        scope.dispatcherType = dispatcherType;

                        $timeout(() => {
                            pollProgress(type, idToUse);
                        }, 4000);
                    }

                });

                scope.$on('$destroy', () => { $timeout.cancel(scope.polling); });
                scope.$on('$destroy', restartListener);
            }]
        }
    }
}
